import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { loadChatHistory, deleteChatSession } from '../actions/chatActions'

export default function HistoryRedux() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { sessions, sessionOrder, loading } = useSelector(state => state.chat)
  
  useEffect(() => {
    dispatch(loadChatHistory())
  }, [dispatch])
  
  const handleSessionClick = (sessionId) => {
    navigate(`/chat/${sessionId}`)
  }
  
  const handleDeleteSession = (sessionId) => {
    if (window.confirm('Are you sure you want to delete this chat session?')) {
      dispatch(deleteChatSession(sessionId))
    }
  }
  
  const sortedSessions = sessionOrder.map(id => sessions[id]).filter(Boolean)
  
  return (
    <div className="container mx-auto p-4">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Chat History</h1>
        <button
          onClick={() => navigate('/chat')}
          className="btn btn-primary"
        >
          New Chat
        </button>
      </div>
      
      {loading ? (
        <div className="flex justify-center py-8">
          <div className="loading loading-spinner loading-lg"></div>
        </div>
      ) : sortedSessions.length === 0 ? (
        <div className="text-center py-8">
          <div className="text-6xl mb-4">📚</div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            No chat history yet
          </h2>
          <p className="text-gray-500 mb-4">
            Start a research conversation to see it here
          </p>
          <button
            onClick={() => navigate('/chat')}
            className="btn btn-primary"
          >
            Start Research
          </button>
        </div>
      ) : (
        <div className="grid gap-4">
          {sortedSessions.map((session) => (
            <div
              key={session.id}
              className="card bg-base-100 shadow-xl cursor-pointer hover:shadow-2xl transition-shadow"
              onClick={() => handleSessionClick(session.id)}
            >
              <div className="card-body">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h2 className="card-title text-lg mb-2 line-clamp-2">
                      {session.title}
                    </h2>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <span>
                        {new Date(session.createdAt).toLocaleDateString()}
                      </span>
                      <span>
                        {new Date(session.createdAt).toLocaleTimeString()}
                      </span>
                      {session.answerId && (
                        <span className="badge badge-success badge-sm">
                          Completed
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="dropdown dropdown-end">
                    <button
                      className="btn btn-ghost btn-sm btn-circle"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                      </svg>
                    </button>
                    <ul className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52">
                      <li>
                        <a onClick={(e) => {
                          e.stopPropagation()
                          handleSessionClick(session.id)
                        }}>
                          Open Chat
                        </a>
                      </li>
                      <li>
                        <a 
                          className="text-error"
                          onClick={(e) => {
                            e.stopPropagation()
                            handleDeleteSession(session.id)
                          }}
                        >
                          Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}